import graphql from "babel-plugin-relay/macro";

export const allRolesDropdown = graphql`
    fragment RolesFragments_AllRolesDropdown on Role @relay(plural:true) {
        id,
        name
    }`